<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <img src="@/assets/logo-land.png" />
        </RouterLink>
      </div>
    </template>
    <template #right>
      <VaDropdown
        v-model="isShownProfileDropDown"
        :offset="[9, 0]"
        :class="`profile-dropdown ${isMobile ? 'mr-1' : 'mr-5'}`"
        stick-to-edges
      >
        <template #anchor>
          <VaButton preset="secondary" color="textPrimary">
            <span class="profile-dropdown__anchor min-w-max">
              <slot />
              <img src="@/assets/ic-user.png" :width="25" />
            </span>
          </VaButton>
        </template>
        <VaDropdownContent
          class="profile-dropdown__content md:w-60 px-0 py-4 w-full"
          :style="{ '--hover-color': hoverColor }"
        >
          <VaList>
            <header class="uppercase text-[var(--va-secondary)] opacity-80 font-bold text-xs px-4">Admin</header>
            <VaListItem class="menu-item px-4 text-base cursor-pointer h-8" @click="logoutTask">
              <VaIcon name="mso-logout" class="pr-1" color="secondary" />
              Logout
            </VaListItem>
          </VaList>
        </VaDropdownContent>
      </VaDropdown>
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useModal, useColors } from 'vuestic-ui'
import { signOut } from 'firebase/auth'
import { useGlobalStore } from '../../stores/global-store'
import { firebaseAuth } from '../../firebase'

const GlobalStore = useGlobalStore()

const { confirm } = useModal()
const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const { isMobile, isSidebarMinimized } = storeToRefs(GlobalStore)
const isShownProfileDropDown = ref(false)

async function logoutTask() {
  const agreed = await confirm({
    title: 'System',
    message: `Are you sure you want to logout now?`,
    okText: 'Yes',
    cancelText: 'No',
    size: 'small',
    maxWidth: '380px',
  })
  if (agreed) {
    signOut(firebaseAuth)
  }
}
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
